<template>
  <aside
    class="component"
    @touchmove.prevent.stop
  >
    <transition
      name="mask"
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
    >
      <div
        v-if="isShow"
        class="dialog-wrap"
      >
        <div class="dialog">
          <slot></slot>
        </div>
        <div
          class="mask"
          @click.stop="touchMask"
        ></div>
      </div>
    </transition>
  </aside>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
const CompDialogChild = Vue.extend({
  name: 'CompDialogTs',
  props: ['isShow'],
});
@Component
export default class CompDialog extends CompDialogChild {
  touchMask() {
    this.$emit('close');
  }
}
</script>
<style lang="scss" scoped>
.component {
  position: fixed;
  top: 0;
  left: 64px;
  z-index: 1001;
  height: 100%;
}

.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100vw;
  background-color: #000;
  opacity: 0.75;
  transition: 200ms linear;
}
.dialog-wrap {
  height: 100%;
}
.dialog {
  position: relative;
  z-index: 1001;
  height: 100%;
  margin: 0 auto;
}

@keyframes bounceIn {
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
    opacity: 0;
  }

  30% {
    transform: scale3d(1.08, 1.08, 1.08);
  }

  50% {
    transform: scale3d(0.95, 0.95, 0.95);
  }

  70% {
    transform: scale3d(1.03, 1.03, 1.03);
    opacity: 1;
  }

  to {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }

  50% {
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
    opacity: 0;
  }

  to {
    opacity: 0;
  }
}

@keyframes bounceOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    transform: scale3d(1.1, 1.1, 1.1);
    opacity: 1;
  }

  to {
    transform: scale3d(0.3, 0.3, 0.3);
    opacity: 0;
  }
}

.zoomOut {
  animation-name: zoomOut;
  animation-duration: 0.75s;
}

.bounceOut {
  animation-name: bounceOut;
  animation-duration: 0.75s;
}

.bounceIn {
  animation-name: bounceIn;
  animation-duration: 0.75s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 0.5s;
}

@keyframes fadeOut {
  from {
    opacity: 0.75;
  }
  to {
    opacity: 0;
  }
}

.fadeOut {
  animation-name: fadeOut;
  animation-duration: 0.5s;
}
</style>
